import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import {
  downloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGet,
  DownloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGetResponse,
  HTTPValidationError,
  client,
} from '@common/config/api/client'

export interface DownloadExamMetadataParams {
  study_id: string
  subject_id: string
  timepoint_submission_id: string
  container_submission_id: string
  dicom_study_uid?: string | null | undefined
  series_uid?: string | null | undefined
}

export const useDownloadExamMetadata = (): UseMutationResult<
  DownloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGetResponse,
  AxiosError<HTTPValidationError>,
  DownloadExamMetadataParams
> => {
  return useMutation<
    DownloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGetResponse,
    AxiosError<HTTPValidationError>,
    DownloadExamMetadataParams
  >({
    mutationFn: async ({
      study_id,
      subject_id,
      timepoint_submission_id,
      container_submission_id,
      dicom_study_uid,
      series_uid,
    }) => {
      const response =
        await downloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGet({
          client,
          path: {
            study_id,
            subject_id,
            timepoint_submission_id,
          },
          query: {
            container_submission_id,
            ...(dicom_study_uid && { dicom_study_uid }),
            ...(series_uid && { series_uid }),
          },
          throwOnError: true,
        })
      return response.data
    },
  })
}
